import {
  Col,
  Card,
  Row,
} from "react-materialize";
import "materialize-css";
import React, { useEffect } from "react";

import wodkan from "./svg/wodkan.svg";
import gaz from "./svg/gaz.svg";
import co from "./svg/co.svg";
import Aos from "aos";
import "aos/dist/aos.css";

function Other() {
  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  return (
    <Row>
      <Col s={12} m={6} l={5} className="left-align">
        <div
          data-aos="zoom-in"
          data-aos-duration="2000"
          className="hoverable z-depth-2 scope"
        >
          <Card className="scope white-text blue darken-2 bold">
            <div className="center">
              <img src={wodkan} width="30%" alt="Instalacje wodno-kanalizacyjne Kraków" />
              <h3 className="bold">Instalacje wodno-kanalizacyjne</h3>
            </div>
            <br />
            <ul>
              <li>usuwanie awarii instalacyjnych</li>
              <li>udrażnianie odpływów kanalizacyjnych</li>
              <li>naprawa spłuczek, kompaktów, systemy podtynkowe GEBERIT, SANIT itp.</li>
              <li>montaż i naprawa baterii, zaworów</li>
              <li>montaż zmywarek, pralek</li>
              <li>montaż umywalek, kabin prysznicowych, WC, wanien</li>
              <li>montaż bojlerów i podgrzewaczy wody</li>
              <li>kompleksowe wykonywanie instalacji wodno-kanalizacyjnych</li>
              <li>przeglądy instalacji wod-kan</li>
              <li>okresowe przeglądy hydroforni</li>
              <li>wymiana elementów instalacji i wodomierzy</li>
              <li>próby ciśnieniowe</li>
            </ul>
          </Card>
        </div>
      </Col>

      <Col s={12} m={6} l={5} push="l2" className="left-align">
        <div
          data-aos="zoom-in"
          data-aos-duration="2500"
          className="hoverable z-depth-2 scope"
        >
          <Card className="scope white-text orange bold">
            <div className="center">
              <img src={gaz} width="30%" alt="Instalacje gazowe Kraków" />
              <h3 className="bold">Instalacje gazowe</h3>
            </div>
            <br />
            <ul>
              <li>usuwanie awarii instalacyjnych</li>
              <li>roczne przeglądy instalacji gazowych</li>
              <li>próby szczelności</li>
              <li>montaż kuchenek gazowych i innych urządzeń</li>
              <li>wymiana bojlerów</li>
              <li>montaż pieców gazowych wszelkiego typu</li>
            </ul>
          </Card>
        </div>
      </Col>

      <Row />

      <Col s={12} m={6} l={5} className="left-align">
        <div
          data-aos="zoom-in"
          data-aos-duration="3000"
          className="hoverable z-depth-2 scope"
        >
          <Card className="scope orange accent-4 white-text bold">
            <div className="center">
              <img src={co} width="30%" alt="Centralne ogrzewanie Kraków" />
              <h3 className="bold">Instalacje centralnego ogrzewania</h3>
            </div>
            <br />
            <ul>
              <li>usuwanie awarii instalacyjnych</li>
              <li>montaż zasobników ciepłej wody</li>
              <li>montaż pieców gazowych wszelkiego typu</li>
              <li>wymiana bojlerów</li>
              <li>ogrzewanie podłogowe</li>
              <li>grzejniki</li>
            </ul>
          </Card>
        </div>
      </Col>

      <Col s={12} m={6} l={5} push="l2" className="left-align">
        <div
          data-aos="zoom-in"
          data-aos-duration="3000"
          className="hoverable z-depth-2 scope"
        >
          <Card className="scope grey darken-3 white-text">
            <h3>Usługi wykończeniowe</h3>
            <br />
            <ul>
              <li>biały montaż</li>
              <li>montaż sprzętów np. zmywarek, pralek itp.</li>
              <li>montaż toalet, wanien, pryszniców itp.</li>
              <li>montaż kuchenek</li>
            </ul>
          </Card>
        </div>
      </Col>

      <Col s={12} m={6} l={5} push="l2" className="left-align">
        <div
          data-aos="zoom-in"
          data-aos-duration="2000"
          className="hoverable z-depth-2 scope"
        >
          <Card className="scope grey darken-3 white-text">
            <h3>Roczne przeglądy</h3>
            <br />
            <ul>
              <li>instalacji gazowych</li>
              <li>próby ciśnieniowe szczelności wod-kan, gaz</li>
            </ul>
          </Card>
        </div>
      </Col>

      <Row />

      <Col s={12} m={6} l={5} className="left-align">
        <div
          data-aos="zoom-in"
          data-aos-duration="2000"
          className="hoverable z-depth-2"
        >
          <Card className="scope red darken-3 white-text">
            <h3>Awarie</h3>
            <br />
            <ul>
              <li>szybki dojazd na terenie Krakowa i okolic</li>
              <li>awarie centralnego ogrzewania</li>
              <li>wod-kan, przecieki, zalania</li>
            </ul>
          </Card>
        </div>
      </Col>

      <Col s={12} m={6} l={5} push="l2" className="left-align">
        <div
          data-aos="zoom-in"
          data-aos-duration="2000"
          className="hoverable z-depth-2"
        >
          <Card className="scope green darken-3 white-text">
            <h3>Przyłącza</h3>
            <br />
            <ul>
              <li>wykonywanie przyłączy wod-kan</li>
            </ul>
          </Card>
        </div>
      </Col>
    </Row>
  );
}

export default Other;
